import type { I18nMessageObject } from '@_/types';
import { useRender } from '@base-ui/react/use-render';
import { useIntl } from 'react-intl';
import { SharedConfig } from '@_/config/shared-config.ts';
import { getI18nValue } from '@_/utils';

export function I18nContent({
  fallback = true,
  i18n,
  locale,
  render
}: {
  fallback?: boolean;
  i18n: I18nMessageObject | undefined;
  locale?: string;
  render?: useRender.RenderProp;
}) {
  const intl = useIntl();

  const resolvedLocale = locale || intl.locale || SharedConfig.defaultLocale;
  const value = getI18nValue(i18n, resolvedLocale, fallback);
  const element = useRender({
    defaultTagName: 'span',
    render,
    enabled: render !== undefined,
    props: { children: value }
  });

  return element ?? <>{value}</>;
}
